import { LoginFields } from "@/modules/login/components/forms/login/login-models";
import { ChangePasswordFields } from "@/modules/login/components/forms/change-password/change-password-models";

export enum ActiveView {
  Login = "Login",
  ChangePassword = "ChangePassword",
}

/** Login State **/

export interface LoginState {
  formFields: LoginFields;
}

export enum LoginErrors {
  NetworkError = "Network Error",
  InvalidUserOrPassword = "Incorrect user name or password",
  UserDeactivated = "User deactivated, contact customer support",
  UserPermanentlyLocked = "User locked, contact customer support",
}

/** Change Password State **/

export interface ChangePasswordState {
  policy: PasswordPolicy;
  policyMap: Map<string, PolicyRule>;
  formFields: ChangePasswordFields;
}

export interface PasswordPolicy {
  min_digits: number;
  min_length: number;
  min_nonletter: number;
  min_special: number;
  min_uppercase: number;
}

export interface PolicyRule {
  text: string;
  regex: RegExp;
}

export enum ChangePasswordErrors {
  UnknownError = "Unknown error",
}
